export default __webpack_public_path__ + "static/media/ic_crm.97c26056.svg";